export default __webpack_public_path__ + "static/media/icon-file-txt-blue-large.ade208b7.svg";